export const isIndiaCountry = (selectedCountry) =>
  selectedCountry?.toLowerCase()?.includes("india");

export const getCoursePricing = (course, selectedCountry) => {
  const isIndia = isIndiaCountry(selectedCountry);

  if (isIndia) {
    const isDiscounted = course.discountAppplied === "Y";
    return {
      isDiscounted,
      originalPrice: course.price,
      finalPrice: course.finalPrice,
      discountValue: course.value,
      discountUnit: course.unit,
      discountedAmount: course.discountedPrice ?? 0,
      currencySymbol: "₹",
    };
  }

  const usPricing = course.usPricing || {};
  const isDiscounted = usPricing.discountApplied === "Y";

  return {
    isDiscounted,
    originalPrice: usPricing.unitPrice ?? course.price,
    finalPrice: usPricing.finalPrice ?? course.price,
    discountValue: usPricing.value,
    discountUnit: usPricing.unit,
    discountedAmount: usPricing.discount ?? 0,
    currencySymbol: "$",
  };
};

export const getCoursePayableAmount = (course, selectedCountry) => {
  const pricing = getCoursePricing(course, selectedCountry);
  return pricing.isDiscounted ? pricing.finalPrice : pricing.originalPrice;
};

export const applyTaxAmount = (amount, ratePercent = 0) => {
  const base = Number(amount) || 0;
  const rate = Number(ratePercent) || 0;
  return Math.round(base * (1 + rate / 100) * 100) / 100;
};
